import React from "react";
export default function ReadTool({ payload, result }) {
  const path = payload?.input?.file_path || "";
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>File</h5>
        <pre className="tool-pre">{path}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Content {result.is_error ? "(error)" : ""}</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
          {result.has_more && <div className="tool-truncated">…truncated.</div>}
        </div>
      )}
    </div>
  );
}
ReadTool.summarize = (p) => p?.input?.file_path || "";
